import React, { useEffect, useState, useRef } from "react";
import './projectdetail.css'
// import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from "framer-motion";
import dakzy1 from '../../../img/1.png';
import dakzy2 from '../../../img/3.png';
import dakzy3 from '../../../img/dakzy-mobile.png';
import dakzy4 from '../../../img/dakzy-mobile-2.png';
import dakzy5 from '../../../img/dakzy_img_1.png';
import dakzy6 from '../../../img/dakzy_img_2.png';   
import dakzy7 from '../../../img/dakzy_img_3.png';
import dakzy8 from '../../../img/dakzy_img_4.png';
import dakzy9 from '../../../img/dakzy_img_5.png';


const containerVariants = {
   hidden: { opacity: 0, y: 40 },
   show: {
      opacity: 1,
      y: 0,
      transition: {
         staggerChildren: 0.3,
         ease: "easeOut",
         duration: 0.6
      }
   }
};

const childVariants = {
   hidden: { opacity: 0, y: 30 },
   show: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const Dakzy = () => {
   //  Animation Heading 

   const [visible1, setVisible1] = useState(false); // DAKZY
   const [visible2, setVisible2] = useState(false); // Challenges & Difficulties
   const [visible3, setVisible3] = useState(false); // Technologies Used
   const [visible4, setVisible4] = useState(false); // Key Features

   const heading1Ref = useRef();
   const heading2Ref = useRef();
   const heading3Ref = useRef();
   const heading4Ref = useRef();

   const letters1 = ["D", "A", "K", "Z", "Y"];
   const letters2_line1 = ["C", "h", "a", "l", "l", "e", "n", "g", "e", "s"];
   const letters2_line2 = ["&", " ", "D", "i", "f", "f", "i", "c", "u", "l", "t", "i", "e", "s"];
   const letters3_line1 = ["T", "e", "c", "h", "n", "o", "l", "o", "g", "i", "e", "s"];
   const letters3_line2 = ["U", "s", "e", "d"];
   const letters4_line1 = ["K", "e", "y", "\u00A0", "F", "e", "a", "t", "u", "r", "e", "s"];


   useEffect(() => {
      const observerOptions = { threshold: 0.3 };

      const createObserver = (setVisible, ref) => {
         const observer = new IntersectionObserver(
            ([entry]) => {
               if (entry.isIntersecting) {
                  setVisible(true);
                  observer.unobserve(ref.current);
               }
            },
            observerOptions
         );
         if (ref.current) observer.observe(ref.current);
      };

      createObserver(setVisible1, heading1Ref);
      createObserver(setVisible2, heading2Ref);
      createObserver(setVisible3, heading3Ref);
      createObserver(setVisible4, heading4Ref);

      return () => { }; // Cleanup skipped for simplicity
   }, []);

   // Animation Images 
   const imageRefs = useRef([]);

   const lerp = (start, end, factor) => {
      return start + (end - start) * factor;
   };

   const updatePosition = () => {
      imageRefs.current.forEach((img) => {
         if (img) {
            const speed = parseFloat(img.dataset.speed) || 0.8;
            const rect = img.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const elementOffsetTop = rect.top + scrollTop;
            const targetY = (scrollTop - elementOffsetTop) * speed;

            if (!img.currentY) img.currentY = 0;
            img.currentY = lerp(img.currentY, targetY, 0.1);

            img.style.transform = `translateY(${img.currentY}px)`;
            img.style.willChange = 'transform';
         }
      });
      requestAnimationFrame(updatePosition);
   };

   useEffect(() => {
      requestAnimationFrame(updatePosition);
   }, []);


   // Animation Slider
   const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      responsive: [
         {
            breakpoint: 768,
            settings: {
               slidesToShow: 1,
               slidesToScroll: 1,
            }
         }
      ]
   };

   const images = [
         dakzy5,
         dakzy6, 
         dakzy7,
         dakzy8,
         dakzy9
   ];
   return (
      <div>
         <style>{`
           @media (max-width: 767px) {
             .tp-section-title-160,
             .tp-section-title-160 span,
             .tp-section-title-160 .char {
               font-size: 24px !important;
               line-height: 1.2 !important;
               margin: 0 !important;
               padding: 0 !important;
               letter-spacing: -0.5px !important;
               word-break: break-word !important;
               white-space: normal !important;
               max-width: 100vw !important;
               overflow-x: hidden !important;
               display: inline-block !important;
             }
             .tp-section-title-160 .word-break {
               display: block !important;
               width: 100%;
               height: 0;
             }
           }
         `}</style>
         <div id="smooth-wrapper">
            <div id="smooth-content">

               <main>

                  {/* <!-- project details area start --> */}

                  <div className="tp-project-details-3-top tp-project-details-3-ptb">
                     <div className="container container-1560">
                        <div className="row">
                           <div className="col-xl-12">
                              <div className="tp-project-details-3-title-box">
                                 {/* <h2 className="tp-section-title-160 mb-50 tp-char-animation">DAKZY</h2> */}
                                 <h2 ref={heading1Ref} className="tp-section-title-160 mb-50 tp-char-animation">
                                    {letters1.map((letter, index) => (
                                       <span
                                          key={`dakzy-${index}`}
                                          className={`char ${visible1 ? "visible" : ""}`}
                                          style={{ animationDelay: `${index * 0.1}s` }}
                                       >
                                          {letter}
                                       </span>
                                    ))}
                                 </h2>
                                 <motion.p
                                    className="project-text px-6 py-8"
                                    initial={{ opacity: 0, y: 40 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.8, ease: "easeOut" }}
                                    viewport={{ once: true, amount: 0.3 }}
                                 >
                                    Develop a luxury jewelry commerce platform with an elegant and premium design. <br />
                                    Ensure a seamless shopping experience with high-quality images, AR-based virtual try ons, and an intuitive UI/UX. <br />
                                    Implement a secure and scalable architecture to handle high-traffic loads. <br />
                                    Integrate personalized product recommendations using AI-driven algorithms. <br />
                                    Provide multi-payment options including EMI, UPI, wallets, and credit/debit cards. <br />
                                    Enhance customer trust with verified jewelry certifications and detailed product descriptions.
                                 </motion.p>
                              </div>
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-xl-6">
                              <div className="tp-project-details-3-scroll smooth">
                                 <a href="#xyz">
                                    <span>
                                       <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M7.5 0L7.5 16.7586" stroke="currentcolor" stroke-width="1.5" stroke-miterlimit="10" />
                                          <path d="M0 10.1582C4.14553 10.1582 7.5 13.6652 7.5 17.9991" stroke="currentcolor" stroke-width="1.5" stroke-miterlimit="10" />
                                          <path d="M7.5 17.9991C7.5 13.6652 10.8545 10.1582 15 10.1582" stroke="currentcolor" stroke-width="1.5" stroke-miterlimit="10" />
                                       </svg>
                                    </span>
                                    Scroll to Explore
                                 </a>
                              </div>
                           </div>
                           <div className="col-xl-6">
                              <div className="tp-project-details-3-link mt-30 text-start text-md-end">
                                 <a href="https://dakzy.com/">
                                    Visit  Website
                                    <span>
                                       <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1 9L9 1" stroke="currentcolor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M1 1H9V9" stroke="currentcolor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                       </svg>
                                    </span>
                                 </a>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  {/* <div className="tp-project-details-3-full-width-thumb mb-120 FOT-img">
               <img data-speed=".8" src="../img/1.png" alt=""/>
            </div> */}
                  <div className="tp-project-details-3-full-width-thumb mb-120 FOT-img" style={{ overflow: 'hidden' }}>
                     <img
                        ref={(el) => (imageRefs.current[0] = el)}
                        data-speed=".8"
                        src={dakzy1}
                        alt=""
                        style={{ transform: 'translateY(0px)' }}
                     />
                  </div>

                  <div className="showcase-details-2-area pb-120">
                     <div className="container">
                        <div className="row">
                           <div className="col-xl-12">
                              <div className="showcase-details-2-section-box project-detail-heading">

                                 <h4 ref={heading2Ref} className="showcase-details-2-section-title tp-char-animation">
                                    <span style={{ display: "inline-block" }}>
                                       {letters2_line1.map((letter, index) => (
                                          <span
                                             key={`challenge1-${index}`}
                                             className={`char ${visible2 ? "visible" : ""}`}
                                             style={{ animationDelay: `${index * 0.1}s` }}
                                          >
                                             {letter}
                                          </span>
                                       ))}
                                    </span>
                                    <br />
                                    <span style={{ display: "inline-block" }}>
                                       {letters2_line2.map((letter, index) => (
                                          <span
                                             key={`challenge2-${index}`}
                                             className={`char ${visible2 ? "visible" : ""}`}
                                             style={{ animationDelay: `${(letters2_line1.length + index) * 0.1}s` }}
                                          >
                                             {letter}
                                          </span>
                                       ))}
                                    </span>
                                 </h4>
                              </div>
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-xl-3">
                              <div className="showcase-details-2-section-left">
                                 <span className="ab-inner-subtitle mb-25">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M12 0C12 3.0432 9.53292 5.5102 6.48975 5.5102C6.48975 2.46701 8.95677 0 12 0Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M0.0231934 0.0231209C3.06639 0.0231209 5.5334 2.49015 5.5334 5.53333C2.4902 5.53333 0.0231934 3.0663 0.0231934 0.0231209Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M6.48975 6.4898C9.53294 6.4898 12 8.95682 12 12C8.95675 12 6.48975 9.53297 6.48975 6.4898Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M5.5102 6.48981C5.5102 9.533 3.04318 12 0 12C0 8.95681 2.46703 6.48981 5.5102 6.48981Z"
                                          fill="currentcolor" />
                                    </svg>
                                    An introduction
                                 </span>
                              </div>
                           </div>
                           <div className="col-xl-9">


                              <motion.div
                                 className="showcase-details-2-content-right tp_title_anim px-6 py-8 project-detail-texts"
                                 variants={containerVariants}
                                 initial="hidden"
                                 whileInView="show"
                                 viewport={{ once: true, amount: 0.3 }}
                              >
                                 <motion.p variants={childVariants} className="pb-6">
                                    A High-Quality Image Optimization – Managing HD images without
                                    compromising site speed. <br />
                                    A Luxury UI/UX Design – Creating a premium feel while maintaining fast
                                    performance. <br />
                                    A Virtual Try-On Feature – Implementing an AI-powered AR solution for
                                    trying jewelry.
                                 </motion.p>

                                 <motion.p variants={childVariants}>
                                    Secure Transactions – Ensuring top-tier security for high-value
                                    transactions. <br />
                                    A Custom Order Management – Providing personalization options for
                                    jewelry designs.
                                 </motion.p>
                              </motion.div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div id="xyz" className="tp-project-details-3-thumb mb-120">
                     <div className="container container-1560">
                        <div className="row">
                           <div className="col-xl-12">
                              {/* <div className="tp-project-details-3-thumb-box">
                           <img data-speed=".8" className="w-100" src="../img/3.png" alt=""/>
                        </div> */}
                              <div className="tp-project-details-3-thumb-box" style={{ overflow: 'hidden' }}>
                                 <img
                                    ref={(el) => (imageRefs.current[1] = el)}
                                    data-speed=".8"
                                    src={dakzy2}
                                    alt=""
                                    className="w-100"
                                    style={{ transform: 'translateY(0px)' }}
                                 />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className="showcase-details-2-area pb-120">
                     <div className="container">
                        <div className="row">
                           <div className="col-xl-8">
                              <div className="showcase-details-2-section-box project-detail-heading">

                                 {/* <h4 class="showcase-details-2-section-title tp-char-animation">Technologies Used</h4> */}
                                 <h4 ref={heading3Ref} className="showcase-details-2-section-title tp-char-animation">
                                    <span style={{ display: "inline-block" }}>
                                       {letters3_line1.map((letter, index) => (
                                          <span
                                             key={`tech1-${index}`}
                                             className={`char ${visible3 ? "visible" : ""}`}
                                             style={{ animationDelay: `${index * 0.1}s` }}
                                          >
                                             {letter}
                                          </span>
                                       ))}
                                    </span>
                                    <br />
                                    <span style={{ display: "inline-block" }}>
                                       {letters3_line2.map((letter, index) => (
                                          <span
                                             key={`tech2-${index}`}
                                             className={`char ${visible3 ? "visible" : ""}`}
                                             style={{ animationDelay: `${(letters3_line1.length + index) * 0.1}s` }}
                                          >
                                             {letter}
                                          </span>
                                       ))}
                                    </span>
                                 </h4>

                              </div>
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-xl-3">
                              <div className="showcase-details-2-section-left">
                                 <span className="ab-inner-subtitle mb-25">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M12 0C12 3.0432 9.53292 5.5102 6.48975 5.5102C6.48975 2.46701 8.95677 0 12 0Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M0.0231934 0.0231209C3.06639 0.0231209 5.5334 2.49015 5.5334 5.53333C2.4902 5.53333 0.0231934 3.0663 0.0231934 0.0231209Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M6.48975 6.4898C9.53294 6.4898 12 8.95682 12 12C8.95675 12 6.48975 9.53297 6.48975 6.4898Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M5.5102 6.48981C5.5102 9.533 3.04318 12 0 12C0 8.95681 2.46703 6.48981 5.5102 6.48981Z"
                                          fill="currentcolor" />
                                    </svg>
                                    An introduction
                                 </span>
                              </div>
                           </div>
                           <div className="col-xl-9">

                              <motion.div
                                 className="showcase-details-2-content-right tp_title_anim px-6 py-8 project-detail-texts"
                                 variants={containerVariants}
                                 initial="hidden"
                                 whileInView="show"
                                 viewport={{ once: true, amount: 0.3 }}
                              >
                                 <motion.p className="project-detail-text" variants={childVariants}>
                                    <strong>Frontend:</strong> React.js, Next.js, Tailwind CSS
                                 </motion.p>
                                 <motion.p className="project-detail-text" variants={childVariants}>
                                    <strong>Backend:</strong> Node.js, Express.js
                                 </motion.p>
                                 <motion.p className="project-detail-text" variants={childVariants}>
                                    <strong>Database:</strong> MongoDB
                                 </motion.p>
                                 <motion.p className="project-detail-text" variants={childVariants}>
                                    <strong>Payment:</strong> Razorpay, Stripe, PayPal
                                 </motion.p>
                                 <motion.p className="project-detail-text" variants={childVariants}>
                                    <strong>Cloud & Hosting:</strong> AWS, DigitalOcean
                                 </motion.p>
                                 <motion.p className="project-detail-text" variants={childVariants}>
                                    <strong>Security:</strong> SSL Encryption, Multi-Factor Authentication
                                 </motion.p>
                              </motion.div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className="tp-project-details-3-thumb mb-90">
                     <div className="container">
                        <div className="row">
                           <div className="col-xl-6">
                              <div className="tp-project-details-3-thumb-box mb-30">
                                 <img className="w-100" src={dakzy3} alt="" />
                              </div>
                           </div>
                           <div className="col-xl-6">
                              <div className="tp-project-details-3-thumb-box mb-30">
                                 <img className="w-100" src={dakzy4} alt="" />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className="showcase-details-2-area pb-120">
                     <div className="container">
                        <div className="row">
                           <div className="col-xl-8">
                              <div className="showcase-details-2-section-box">
                                 {/* <h4 className="showcase-details-2-section-title tp-char-animation">Key Features</h4> */}
                                 <h4 ref={heading4Ref} className="showcase-details-2-section-title tp-char-animation">
                                    <span style={{ display: "inline-block" }}>
                                       {letters4_line1.map((letter, index) => (
                                          <span
                                             key={`feature1-${index}`}
                                             className={`char ${visible4 ? "visible" : ""}`}
                                             style={{ animationDelay: `${index * 0.1}s` }}
                                          >
                                             {letter}
                                          </span>
                                       ))}
                                    </span>

                                 </h4>

                              </div>
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-xl-3">
                              <div className="showcase-details-2-section-left">
                                 <span className="ab-inner-subtitle mb-25">
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M12 0C12 3.0432 9.53292 5.5102 6.48975 5.5102C6.48975 2.46701 8.95677 0 12 0Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M0.0231934 0.0231209C3.06639 0.0231209 5.5334 2.49015 5.5334 5.53333C2.4902 5.53333 0.0231934 3.0663 0.0231934 0.0231209Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M6.48975 6.4898C9.53294 6.4898 12 8.95682 12 12C8.95675 12 6.48975 9.53297 6.48975 6.4898Z"
                                          fill="currentcolor" />
                                       <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M5.5102 6.48981C5.5102 9.533 3.04318 12 0 12C0 8.95681 2.46703 6.48981 5.5102 6.48981Z"
                                          fill="currentcolor" />
                                    </svg>
                                    An introduction
                                 </span>
                              </div>
                           </div>
                           <div className="col-xl-9">

                              <motion.div
                                 className="showcase-details-2-content-right tp_title_anim px-6 py-8"
                                 variants={containerVariants}
                                 initial="hidden"
                                 whileInView="show"
                                 viewport={{ once: true, amount: 0.3 }}
                              >
                                 {[
                                    "→ Elegant UI/UX with Premium Design Aesthetics.",
                                    "→ AI-Based Personalized Jewelry Recommendations.",
                                    "→ AR Virtual Try-On for Rings, Necklaces & Earrings.",
                                    "→ Multi-Payment Support (EMI, UPI, Wallets, Credit/Debit Cards).",
                                    "→ Real-Time Order Tracking & Shipping Updates.",
                                    "→ Jewelry Certification & Product Authenticity Details.",
                                    "→ Wishlist & Compare Products Feature.",
                                    "→ Multi-Language & Multi-Currency Support.",
                                    "→ SEO-Optimized Product Pages for Better Search Visibility.",
                                    "→ Customer Reviews & Video Testimonials.",
                                    "→ Referral & Loyalty Rewards Program.",
                                 ].map((text, index) => (
                                    <motion.p
                                       key={index}
                                       className="project-detail-text"
                                       variants={childVariants}
                                    >
                                       {text}
                                    </motion.p>
                                 ))}
                              </motion.div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className="pd-visual-slider-wrap pb-40">
                     <div className="slider-container">
                        <Slider {...settings}>
                           {images.map((src, index) => (
                              <div key={index} className="image-wrapper">
                                 <div className="image-wrapper-inner">
                                    <img src={src} alt={`Slide ${index + 1}`} />
                                 </div>
                              </div>
                           ))}
                        </Slider>
                     </div>
                  </div>



               </main>


            </div>
         </div>
      </div>
   )
}

export default Dakzy